import $ from 'jquery';

class Header {
    constructor () {
        this.menuClass        = 'js-main-menu';
        this.$menu            = $(`.${this.menuClass}`);
        this.menuItemSelector = 'js-menu-item';
        this.$menuItems       = $(`.${this.menuItemSelector}.menu-item-has-children`);

        this.searchBtnClass  = 'js-search-btn';
        this.$searchBtn      = $(`.${this.searchBtnClass}`);
        this.searchFormClass = 'js-search-form';
        this.$searchForm     = $(`.${this.searchFormClass}`);

        this.burgerBtnClass = 'js-burger-btn';
        this.$burgerBtn     = $(`.${this.burgerBtnClass}`);

        this.$subMenus = $('.js-sub-menu__list');

        this.$menuItems.on('click', $.proxy(this.menuClick, this));
        this.$searchBtn.on('click', $.proxy(this.searchClick, this));
        this.$burgerBtn.on('click', $.proxy(this.burgerClick, this));

        this.menuColumns();
    }

    menuClick (e) {
        let $elem = $(e.target);

        if ($elem.hasClass('js-menu-link')) {
            $elem = $elem.parent();
        }

        e.stopPropagation();

        if ($elem.hasClass(this.menuItemSelector)) {
            e.preventDefault();

            const $openSiblings = $elem.siblings('.is-open');
            let delay           = 0;

            // Close other menu items
            if ($openSiblings.length) {
                Header.closeMenuItems($openSiblings);

                delay = 301;
            }

            // Close search form
            if (this.isSearchOpen()) {
                this.closeSearchForm();

                delay = 301;
            }

            setTimeout(() => {
                $elem.toggleClass('is-open').find('.js-sub-menu').slideToggle(300);
            }, delay);
        }
    }

    searchClick (e) {
        const $elem          = $(e.currentTarget);
        const $openMenuItems = this.getOpenMenuItems();
        const $searchForm    = this.$searchForm;
        let delay            = 0;

        // Close other menu items
        if ($openMenuItems.length) {
            Header.closeMenuItems($openMenuItems);

            delay = 301;
        }

        if (this.$burgerBtn.hasClass('is-open') && this.$burgerBtn.is(':visible')) {
            this.$burgerBtn.trigger('click');
        }

        setTimeout(() => {
            $elem.toggleClass('is-open');
            $searchForm.slideToggle(300);
        }, delay);
    }

    burgerClick () {
        if (this.$burgerBtn.hasClass('is-open')) {
            this.closeBurger();
        } else {
            this.openBurger();
        }

        this.closeSearchForm();
    }

    closeBurger () {
        this.$burgerBtn.removeClass('is-open');

        if (this.$burgerBtn.is(':visible')) {
            this.$menu.slideUp(300);
        }
    }

    openBurger () {
        this.$burgerBtn.addClass('is-open');

        if (this.$burgerBtn.is(':visible')) {
            this.$menu.slideDown(300);
        }
    }

    getOpenMenuItems () {
        return this.$menuItems.filter('.is-open');
    }

    static closeMenuItems ($elems) {
        $elems.removeClass('is-open').find('.js-sub-menu').slideUp(300);
    }

    isSearchOpen () {
        return this.$searchBtn.hasClass('is-open');
    }

    closeSearchForm () {
        this.$searchBtn.removeClass('is-open');
        this.$searchForm.slideUp(300);
    }

    // Counts menu items and adds a new class if more than three
    menuColumns () {
        this.$subMenus.each(function () {
            const itemCount = $(this).find('.js-sub-menu__item').length;

            if (itemCount > 3) {
                $(this).addClass('more-than-three');
            }
        });
    }
}

export default Header;
